import { Dialog, Listbox } from "@headlessui/react";
import { useEffect, useState } from "react";
import { format, isValid } from "date-fns";
import { toast } from "react-toastify";

import { Fragment } from "react";
import api from "../../Utils/api";

import { formatInTimeZone } from "date-fns-tz";
import Spinner from "../Spinner";

const UTC = "UTC";

export default function EventDialog({
  date,
  isOpen,
  onClose,
  locations,
  users,
  getSchedules,
  modify,
  modifyData,
  selectedUserID,
  selectedLocationID,
}) {
  const [eventText, setEventText] = useState("");

  const [startStr, setStartStr] = useState("08:00");
  const [endStr, setEndStr] = useState("17:00");

  const [breakStartStr, setBreakStartStr] = useState("12:00");
  const [breakEndStr, setBreakEndStr] = useState("12:00");

  const [userID, setUserID] = useState(null);
  const [locationID, setLocationID] = useState(null);
  const [selectDate, setSelectedDate] = useState(date);

  const [shiftType, setShiftType] = useState("");
  const [shiftStatus, setShiftStatus] = useState("");
  const [candidates, setCandidates] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [showWideDialog, setShowWideDialog] = useState(false);

  useEffect(() => {
    if (modify) {
      if (modifyData != null) {
        setModifyData();
      }
      setShowWideDialog(
        modifyData["type"] == "shift_swap" ||
          modifyData["type"] == "shift_offer"
      );

      if (
        modifyData["type"] == "shift_swap" ||
        modifyData["type"] == "shift_offer"
      ) {
        getCandidates(modifyData);
      }
    } else {
      clearFields();
    }
  }, [modify]);

  useEffect(() => {
    setSelectedDate(date);
  }, [date]);

  useEffect(() => {
    if (selectedLocationID != undefined && selectedLocationID != "") {
      setLocationID(selectedLocationID);
    }
  }, [selectedLocationID]);

  useEffect(() => {
    if (selectedUserID !== undefined && selectedUserID !== "") {
      setUserID(selectedUserID);
    }
  }, [selectedUserID]);

  const getCandidates = async (data) => {
    let shiftType = data["type"];
    let candidates = data["candidates"];

    if (shiftType == "shift_swap") {
      setShiftType("shift_swap");

      // console.log(candidates);

      let shiftIDs = candidates.map((shift) => shift.scheduleID);
      const res = await api.post("/schedule/swap_candidate_list", shiftIDs);

      if (res.data.success) {
        if (res.data.success) {
          const merged = res.data.candidates.map((newItem) => {
            const oldItem = candidates.find(
              (c) => c.scheduleID === newItem._id
            );

            delete oldItem._id;
            delete oldItem.id;

            return {
              ...newItem,
              ...(oldItem || {}),
            };
          });

          setCandidates(merged);
        }
      }
    }

    if (shiftType == "shift_offer") {
      setShiftType("shift_offer");

      let userIDs = candidates.map((shift) => shift.user);

      const res = await api.post("/schedule/offer_candidate_list", userIDs);

      if (res.data.success) {
        if (res.data.success) {
          const merged = res.data.candidates.map((newItem) => {
            const oldItem = candidates.find((c) => c.user === newItem._id);

            delete oldItem._id;
            delete oldItem.id;

            return {
              ...newItem,
              ...(oldItem || {}),
            };
          });

          setCandidates(merged);
        }
      }
    }
  };

  const submitEvent = async () => {
    // Validate inputs
    if (!locationID || !startStr || !endStr || !userID) {
      toast.warn("Please Fill in All Required Fields Correctly!");
      return;
    }
    const event = {
      eventText,
      locationID,
      startTime: mergeDateAndTime(selectDate, startStr),
      endTime: mergeDateAndTime(selectDate, endStr),
      breakStartTime: mergeDateAndTime(selectDate, breakStartStr),
      breakEndTime: mergeDateAndTime(selectDate, breakEndStr),
    };

    if (
      mergeDateAndTime(selectDate, startStr) >
      mergeDateAndTime(selectDate, endStr)
    ) {
      toast.warn("Incorrect Start/End time!");
      return;
    }

    if (
      mergeDateAndTime(selectDate, breakStartStr) >
      mergeDateAndTime(selectDate, breakEndStr)
    ) {
      toast.warn("Incorrect break Start/End time!");
      return;
    }

    if (userID == "open") {
      event["type"] = "open";
    } else if (userID == "empty") {
      event["type"] = "empty";
    } else if (userID == "open_claim") {
      event["type"] = "open_claim";
    } else if (userID != "") {
      event["userID"] = userID;
    }

    setIsLoading(true);
    const res = await api.post(`/schedule`, event);
    setIsLoading(false);

    if (res.data.success) {
      toast.success("Event added successfully");
      getSchedules();
    } else if (res.data.status == "warn") {
      toast.warn(res.data.message);
    } else {
      toast.error("Failed to add event");
      return;
    }

    // Clear form fields
    clearFields();

    // Add event to the calendar state
    //...
    onClose();
  };

  const clearFields = () => {
    setEventText("");
    setStartStr("08:00");
    setEndStr("17:00");
    setBreakStartStr("12:00");
    setBreakEndStr("12:00");
    // setUserID(null);
    // setLocationID(null);
  };

  const updateEvent = async () => {
    // Validate inputs
    if (
      !userID ||
      !locationID ||
      !startStr ||
      !endStr ||
      !breakStartStr ||
      !breakEndStr
    ) {
      toast.warn("Please Fill in All Required Fields Correctly!");
      return;
    }

    const event = {
      eventText,
      userID,
      locationID,
      startTime: mergeDateAndTime(selectDate, startStr),
      endTime: mergeDateAndTime(selectDate, endStr),
      breakStartTime: mergeDateAndTime(selectDate, breakStartStr),
      breakEndTime: mergeDateAndTime(selectDate, breakEndStr),
    };

    if (
      mergeDateAndTime(selectDate, startStr) >
      mergeDateAndTime(selectDate, endStr)
    ) {
      toast.warn("Incorrect Start/End time!");
      return;
    }

    if (
      mergeDateAndTime(selectDate, breakStartStr) >
      mergeDateAndTime(selectDate, breakEndStr)
    ) {
      toast.warn("Incorrect break Start/End time!");
      return;
    }
    setIsLoading(true);

    const res = await api.post(`/schedule/update`, {
      _id: modifyData._id,
      updatedData: event,
      manual: true,
    });

    setIsLoading(false);
    if (res.data.success) {
      toast.success("Event added successfully");
      getSchedules();
    } else if (res.data.status == "warn") {
      toast.warn(res.data.message);
    } else {
      toast.error("Failed to add event");
      return;
    }

    // Clear form fields
    clearFields();

    // Add event to the calendar state
    //...
    onClose();
  };

  const createDateAsISO = (dateStr) => {
    const [year, month, day] = dateStr.split("-").map(Number);
    const localDate = new Date(year, month - 1, day);
    localDate.setUTCHours(0, 0, 0, 0);
    let ISODateStr = localDate.toISOString();
    return new Date(ISODateStr); // Automatically converts to ISO in UTC
  };

  const mergeDateAndTime = (date, timeStr, isUTC = true) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const newDate = new Date(date);

    if (isUTC) {
      newDate.setUTCHours(hours); // Sets the hours in UTC
      newDate.setUTCMinutes(minutes); // Sets the minutes in UTC
    } else {
      newDate.setUTCHours(hours); // Sets the hours in local time
      newDate.setMinutes(minutes); // Sets the minutes in local time
    }

    newDate.setSeconds(0); // Reset the seconds to 0
    newDate.setMilliseconds(0); // Optional: Reset milliseconds to 0

    return newDate;
  };

  const deleteEvent = async () => {
    const confirmDelete = window.confirm(
      `Are you sure to delete this schedule?`
    );

    if (!confirmDelete) return;

    setIsLoading(true);
    const res = await api.delete(`/schedule/${modifyData._id}`);
    setIsLoading(false);
    if (res.data.success) {
      toast.success("Event Deleted successfully");
      getSchedules();
    } else {
      toast.error("Failed to delete event");
    }
    onClose();
    getSchedules();
    clearFields();
  };

  const setModifyData = () => {
    setEventText(modifyData.eventText);
    setUserID(modifyData.userID?._id);
    setLocationID(modifyData.locationID?._id);
    setStartStr(formatInTimeZone(modifyData.startTime, UTC, "HH:mm"));
    setEndStr(formatInTimeZone(modifyData.endTime, UTC, "HH:mm"));

    setBreakStartStr(
      modifyData.breakStartTime && isValid(new Date(modifyData.breakStartTime))
        ? formatInTimeZone(new Date(modifyData.breakStartTime), UTC, "HH:mm")
        : "12:00"
    );

    setBreakEndStr(
      modifyData.breakEndTime && isValid(new Date(modifyData.breakEndTime))
        ? formatInTimeZone(new Date(modifyData.breakEndTime), UTC, "HH:mm")
        : "12:00"
    );

    setSelectedDate(new Date(modifyData.startTime)); // Keep this if you want local Date object
  };

  const getTimeDiffFormatted = (
    shiftStart,
    shiftEnd,
    breakStart = null,
    breakEnd = null
  ) => {
    const parse = (timeStr) => {
      const [time, period] = timeStr.split(" ");
      let [hour, minute] = time.split(":").map(Number);

      if (period === "PM" && hour !== 12) hour += 12;
      if (period === "AM" && hour === 12) hour = 0;

      return hour * 60 + minute;
    };

    let shiftStartMin = parse(shiftStart);
    let shiftEndMin = parse(shiftEnd);

    // Handle overnight shift (e.g. 10:00 PM to 2:00 AM)
    if (shiftEndMin < shiftStartMin) shiftEndMin += 24 * 60;

    let totalShiftMin = shiftEndMin - shiftStartMin;

    let breakMin = 0;
    if (breakStart && breakEnd) {
      let breakStartMin = parse(breakStart);
      let breakEndMin = parse(breakEnd);

      // Handle overnight break (rare but possible)
      if (breakEndMin < breakStartMin) breakEndMin += 24 * 60;

      breakMin = breakEndMin - breakStartMin;
    }

    const netMin = totalShiftMin - breakMin;

    const hours = Math.floor(netMin / 60);
    const minutes = netMin % 60;

    return `${hours}h ${minutes}min`;
  };

  const formatTime = (timeString) => {
    if (!timeString) return "-";
    const date = new Date(timeString);

    // Format the time using Intl.DateTimeFormat
    return new Intl.DateTimeFormat([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // use false for 24-hour format, true for AM/PM
      timeZone: "UTC", // optional: remove if you want local time
    }).format(date);
  };
  const formatDay = (timeString) => {
    if (!timeString) return "-";
    const date = new Date(timeString);
    return date.toISOString().split("T")[0]; // returns 'YYYY-MM-DD'
  };

  const approveNowork = async (userID, shiftType) => {
    let res;

    setIsLoading(true);
    if (shiftType == "shift_offer") {
      res = await api.post("/schedule/approve_offer", {
        scheduleID: modifyData._id,
        userID: userID,
        type: shiftType,
      });
    } else {
      res = await api.post("/schedule/approve_swap", {
        scheduleID: modifyData._id,
        userID: userID,
        type: shiftType,
      });
    }
    setIsLoading(false);
    if (res.data.success) {
      toast.success(res.data.message);
      getSchedules();
      onClose();
    } else {
      toast.error(res.data.message);
    }
  };

  const approveSwap = async () => {};

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="fixed inset-0 flex items-center justify-center z-50"
    >
      {isLoading && <Spinner />}
      <div className="fixed inset-0 bg-black opacity-50" aria-hidden="true" />
      <div
        className={`bg-white rounded-lg p-6 ${
          showWideDialog ? "max-w-5xl" : "max-w-lg"
        }  w-full relative z-10`}
      >
        <div className="flex">
          <div className="max-w-2xl w-full">
            <div className="flex justify-between items-center mb-4">
              <i className="fa-solid fa-user-tie text-sm w-4  text-gray-400 mr-4"></i>
              <Listbox value={userID} onChange={setUserID}>
                <div className="relative w-full ">
                  <Listbox.Button className="w-full bg-gray-50 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-gray-500 text-left">
                    {(() => {
                      const user = users.find((u) => u._id === userID);
                      return user ? (
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <div>
                              <div className="text-sm font-medium">
                                {user.preferredName}
                              </div>
                              <div className="text-xs text-gray-500">
                                {user.email}
                              </div>
                            </div>
                          </div>
                          <div className="text-xs text-gray-500 font-semibold">
                            15h 40m
                          </div>
                        </div>
                      ) : userID == "empty" ? (
                        <div className="flex items-center justify-between w-full">
                          <div className="flex items-center gap-2">
                            <div>
                              <div className="text-sm font-medium">
                                {"Empty Shift"}
                              </div>
                              <div className="text-xs text-gray-500"></div>
                            </div>
                          </div>
                          <div className="text-xs text-gray-500 font-semibold"></div>
                        </div>
                      ) : userID == "open" ? (
                        <div className="flex items-center justify-between w-full">
                          <div className="flex items-center gap-2">
                            <div>
                              <div className="text-sm font-medium">
                                {"Open Shift"}
                              </div>
                              <div className="text-xs text-gray-500"></div>
                            </div>
                          </div>
                          <div className="text-xs text-gray-500 font-semibold"></div>
                        </div>
                      ) : userID == "open_claim" ? (
                        <div className="flex items-center justify-between w-full">
                          <div className="flex items-center gap-2">
                            <div>
                              <div className="text-sm font-medium">
                                {"Open Shift with Claim"}
                              </div>
                              <div className="text-xs text-gray-500"></div>
                            </div>
                          </div>
                          <div className="text-xs text-gray-500 font-semibold"></div>
                        </div>
                      ) : (
                        <span className="text-gray-400">Select a user</span>
                      );
                    })()}
                  </Listbox.Button>
                  <Listbox.Options className="absolute z-10 mt-1 w-full bg-white bg-gray-50 rounded-md shadow-lg max-h-60 overflow-auto">
                    <Listbox.Option key={"__1"} value={"empty"} as={Fragment}>
                      {({ active }) => (
                        <li
                          className={`flex items-center gap-3 px-4 py-2 cursor-pointer ${
                            active ? "bg-gray-100" : ""
                          }`}
                        >
                          <div className="flex items-center justify-between w-full">
                            <div className="flex items-center gap-2">
                              <i className="fa-solid fa-user text-gray-400 w-4 ml-1 mr-1 text-sm  rounded-full"></i>
                              <div>
                                <div className="text-sm font-medium">
                                  {"Empty Shift"}
                                </div>
                                <div className="text-xs text-gray-500"></div>
                              </div>
                            </div>
                            <div className="text-xs text-gray-500 font-semibold"></div>
                          </div>
                        </li>
                      )}
                    </Listbox.Option>
                    <Listbox.Option key={"__2"} value={"open"} as={Fragment}>
                      {({ active }) => (
                        <li
                          className={`flex items-center gap-3 px-4 py-2 cursor-pointer ${
                            active ? "bg-gray-100" : ""
                          }`}
                        >
                          <div className="flex items-center w-full">
                            <div className="flex items-center gap-2">
                              <i className="fa-solid fa-user-clock text-gray-400 w-4 ml-1 mr-1 text-sm rounded-full"></i>

                              <div>
                                <div className="text-sm font-medium">
                                  {"Open Shift"}
                                </div>
                                <div className="text-xs text-gray-500"></div>
                              </div>
                            </div>
                            <div className="text-xs text-gray-500 font-semibold"></div>
                          </div>
                        </li>
                      )}
                    </Listbox.Option>
                    {/* <Listbox.Option
                      key={"__3"}
                      value={"open_claim"}
                      as={Fragment}
                    >
                      {({ active }) => (
                        <li
                          className={`flex items-center gap-3 px-4 py-2 cursor-pointer ${
                            active ? "bg-gray-100" : ""
                          }`}
                        >
                          <div className="flex items-center w-full">
                            <div className="flex items-center gap-2">
                              <i className="fa-solid fa-user-check text-gray-400 ml-1 w-5  text-sm rounded-full"></i>

                              <div>
                                <div className="text-sm font-medium">
                                  {"Open Shift with Claim"}
                                </div>
                                <div className="text-xs text-gray-500"></div>
                              </div>
                            </div>
                            <div className="text-xs text-gray-500 font-semibold"></div>
                          </div>
                        </li>
                      )}
                    </Listbox.Option> */}

                    {users.map((user, index) => (
                      <Listbox.Option
                        key={user._id}
                        value={user._id}
                        as={Fragment}
                      >
                        {({ active }) => (
                          <li
                            className={`flex items-center gap-3 px-4 py-2 cursor-pointer ${
                              active ? "bg-gray-100" : ""
                            }`}
                          >
                            <div className="flex items-center justify-between w-full">
                              <div className="flex items-center gap-2">
                                <div className="w-[32px] h-[32px] bg-[#e8e8e8] rounded-full flex items-center justify-center mr-2">
                                  <span className="font-sans text-[18px] text-[#565656] font-semibold leading-[24px]">
                                    {user.firstName &&
                                      user.firstName.charAt(0).toUpperCase()}
                                    {user.lastName &&
                                      user.lastName.charAt(0).toUpperCase()}
                                  </span>
                                </div>
                                <div>
                                  <div className="text-sm font-medium">
                                    {user.preferredName}
                                  </div>
                                  <div className="text-xs text-gray-500">
                                    {user.email}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </div>
              </Listbox>
            </div>
            <hr className="my-2" />
            <div className="flex justify-between items-center mb-4">
              <i className="fa-solid fa-location-dot w-4  text-sm text-gray-400 mr-4"></i>
              <Listbox value={locationID} onChange={setLocationID}>
                <div className="relative w-full">
                  <Listbox.Button className="w-full bg-gray-50 rounded-md p-2 text-left focus:outline-none focus:ring-2 focus:ring-gray-500">
                    {(() => {
                      const loc = locations.find((l) => l._id === locationID);
                      return loc ? (
                        <div className="flex items-center gap-2">
                          <i className="fa fa-map-marker mr-1 w-4 h-4 text-gray-500" />
                          <span className="mr-2">{loc.area}</span>
                          <span>({loc.name})</span>
                        </div>
                      ) : (
                        <span className="text-gray-400">Select a location</span>
                      );
                    })()}
                  </Listbox.Button>
                  <Listbox.Options className="absolute z-10 mt-1 w-full bg-white bg-gray-50 rounded-md shadow-lg max-h-60 overflow-auto">
                    {locations.map((location) => (
                      <Listbox.Option
                        key={location._id}
                        value={location._id}
                        as={Fragment}
                      >
                        {({ active }) => (
                          <li
                            className={`flex items-center gap-2 px-4 py-2 cursor-pointer ${
                              active ? "bg-gray-100" : ""
                            }`}
                          >
                            <i className="fa fa-map-marker mr-1 w-4 h-4 text-gray-500" />
                            <span className="mr-2">{location.area}</span>
                            <span>({location.name})</span>
                          </li>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </div>
              </Listbox>
            </div>
            {modify && (
              <div className="flex justify-between items-center mb-4">
                <i className="fa-solid fa-calendar text-sm w-4  text-gray-400 mr-4"></i>
                <input
                  type="date"
                  value={
                    selectDate ? selectDate?.toISOString().split("T")[0] : ""
                  }
                  onChange={(e) =>
                    setSelectedDate(createDateAsISO(e.target.value))
                  }
                  className="w-full border  border-gray-200 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-gray-500"
                />
              </div>
            )}

            <div className="flex justify-between items-center mb-4">
              <i className="fa-regular fa-clock text-sm w-4 text-gray-400 mr-3"></i>
              <div className="flex items-center w-full">
                <input
                  type="time"
                  value={startStr}
                  onChange={(e) => setStartStr(e.target.value)}
                  className="w-full bg-gray-50 rounded-md mr-2 p-2 focus:outline-none focus:ring-2 focus:ring-gray-500"
                />

                <input
                  type="time"
                  value={endStr}
                  onChange={(e) => setEndStr(e.target.value)}
                  className="w-full bg-gray-50 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-gray-500"
                />
              </div>
            </div>

            <div className="flex justify-between items-center mb-4">
              <i className="fa-solid fa-mug-saucer text-sm w-4  text-gray-400 mr-3"></i>
              <div className="flex items-center w-full">
                <input
                  type="time"
                  value={breakStartStr}
                  onChange={(e) => setBreakStartStr(e.target.value)}
                  className="w-full bg-gray-50 rounded-md mr-2 p-2 focus:outline-none focus:ring-2 focus:ring-gray-500"
                />

                <input
                  type="time"
                  value={breakEndStr}
                  onChange={(e) => setBreakEndStr(e.target.value)}
                  className="w-full bg-gray-50 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-gray-500"
                />
              </div>
            </div>

            <textarea
              placeholder="Add a note..."
              value={eventText}
              onChange={(e) => setEventText(e.target.value)}
              className="w-full bg-gray-50 rounded-md mt-4 p-3 h-16   resize-none mb-4 focus:outline-none focus:ring-2 focus:ring-gray-500"
            />

            <div className="text-sm text-gray-400 mx-2">
              Total:
              <span className="text-md ml-2 text-gray-500 font-semibold">
                {getTimeDiffFormatted(
                  startStr,
                  endStr,
                  breakStartStr,
                  breakEndStr
                )}
              </span>
            </div>
          </div>
          {showWideDialog && (
            <div className="bg-white rounded-lg px-6 max-w-lg w-full relative z-10">
              <div className="text-2xl border-b border-gray-300 mb-4 pb-4">
                {shiftType == "shift_swap" ? "Swap Sent" : "Offer Sent"}
              </div>

              {candidates.map((item) => (
                <div
                  key={item._id}
                  className="relative flex items-center p-4 pb-12 bg-gray-50 mb-2 rounded-lg shadow-sm border border-gray-200"
                >
                  {/* Avatar */}
                  {shiftType == "shift_offer" && (
                    <div className="w-[32px] h-[32px] bg-[#e8e8e8] rounded-full flex items-center justify-center mr-2">
                      <span className="font-sans text-[18px] text-[#565656] font-semibold leading-[24px]">
                        {item.firstName &&
                          item.firstName.charAt(0).toUpperCase()}
                        {item.lastName && item.lastName.charAt(0).toUpperCase()}
                      </span>
                    </div>
                  )}

                  {shiftType == "shift_swap" && (
                    <div className="w-[32px] h-[32px] bg-[#e8e8e8] rounded-full flex items-center justify-center mr-2">
                      <span className="font-sans text-[18px] text-[#565656] font-semibold leading-[24px]">
                        {item.userID.firstName &&
                          item.userID.firstName.charAt(0).toUpperCase()}
                        {item.userID.lastName &&
                          item.userID.lastName.charAt(0).toUpperCase()}
                      </span>
                    </div>
                  )}

                  {/* Info */}
                  <div className="flex-1">
                    <div className="flex justify-between items-center">
                      <div className="text-lg font-semibold text-gray-800">
                        {item?.userID?.preferredName ?? item.preferredName}
                      </div>
                      {!item.accept && !item.decline && (
                        <div className="text-[10px] p-1 ml-2 rounded-md bg-orange-200 text-orange-700 font-semilbold">
                          PENDING
                        </div>
                      )}
                      {item.accept && (
                        <div className="text-[10px] p-1 ml-2 rounded-md bg-green-200 text-green-700 font-semilbold">
                          ACCEPT
                        </div>
                      )}
                      {item.decline && (
                        <div className="text-[10px] p-1 ml-2 rounded-md bg-red-200 text-red-700 font-semilbold">
                          DECLINE
                        </div>
                      )}
                    </div>
                    {shiftType == "shift_swap" && (
                      <>
                        <p className="text-sm text-gray-600 mb-2">
                          {item.locationID.area} - {item.locationID.name}
                        </p>
                        <p className="text-xs font-semibold mb-2">
                          <i
                            className="fa-regular w-4 -mb-1 fa-calendar text-gray-300"
                            aria-hidden="true"
                          ></i>{" "}
                          {formatDay(item.startTime)}
                        </p>
                        <div className="text-xs text-gray-700 space-y-1">
                          <div className="flex items-center space-x-1">
                            <i
                              className="fa-regular w-4 -mb-1 fa-clock text-gray-300"
                              aria-hidden="true"
                            ></i>
                            <span>
                              {formatTime(item.startTime)} -{" "}
                              {formatTime(item.endTime)}
                            </span>
                          </div>

                          {item.breakStartTime && item.breakEndTime && (
                            <div className="flex items-center space-x-1">
                              <i
                                className="fa fa-sold w-4 -mb-1 fa-mug-saucer text-gray-300"
                                aria-hidden="true"
                              ></i>
                              <span>
                                {formatTime(item.breakStartTime)} -{" "}
                                {formatTime(item.breakEndTime)}
                              </span>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  {/* Bottom right button */}
                  <button
                    onClick={() => approveNowork(item.user, shiftType)}
                    className="absolute bottom-4 right-4 bg-green-100 hover:bg-green-400 text-green-800 hover:text-white text-xs px-3 py-1 rounded"
                    type="button"
                  >
                    Approve
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="mt-4 flex justify-end gap-4">
          <button
            onClick={onClose}
            className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400"
          >
            Cancel
          </button>
          {modify ? (
            <>
              <button
                onClick={deleteEvent}
                className="bg-gray-300 text-white px-4 py-2 rounded-md hover:bg-gray-700"
              >
                Delete
              </button>
              <button
                onClick={updateEvent}
                className="bg-green-300 text-white px-4 py-2 rounded-md hover:bg-green-700"
              >
                Update
              </button>
            </>
          ) : (
            <button
              onClick={submitEvent}
              className="bg-gray-300 text-white px-4 py-2 rounded-md hover:bg-gray-700"
            >
              Save
            </button>
          )}
        </div>
      </div>
    </Dialog>
  );
}
